// BenefitsTabs.js
import React, { useState } from 'react';

const BenefitsTabs = () => {
  const [activeTab, setActiveTab] = useState(0);
  const categories = [
    { title: 'Operational', benefits: [
      { title: 'Integrated Solutions', description: 'Comprehensive approach with integrated solutions.' },
      { title: 'Enhanced Efficiency', description: 'Boost operational efficiency by centralizing services.' },
    ] },
    { title: 'Strategic', benefits: [
      { title: 'Strategic Alignment', description: 'Ensure alignment across all functions.' },
      { title: 'Cost-Effective Solutions', description: 'Lower costs by combining services.' },
    ] },
    { title: 'Communication', benefits: [
      { title: 'Improved Communication', description: 'Streamlined processes with a single point of contact.' },
      { title: 'Scalable Services', description: 'Adaptable services that grow with your business.' },
    ] },
  ];

  return (
    <div className="max-w-7xl mx-auto p-6">
        
    <h1 className="text-3xl font-semibold text-center mb-8 text-[#13689b] py-4 rounded-lg">Benefits of Utilizing Our Services</h1>
      <div className="flex space-x-4 mb-6">
        {categories.map((category, index) => (
          <button
            key={index}
            className={`flex-1 py-2 px-2 ${activeTab === index ? 'bg-[#13689b] text-white' : 'bg-gray-200 text-black'} rounded`}
            onClick={() => setActiveTab(index)}
          >
            {category.title}
          </button>
        ))}
      </div>
      <div>
        {categories[activeTab].benefits.map((benefit, index) => (
          <div key={index} className="bg-white rounded-lg shadow-sm p-5 mb-4">
            <h3 className="text-xl font-semibold text-black mb-2">{benefit.title}</h3>
            <p className="text-black">{benefit.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BenefitsTabs;
